import { UserState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const userState: UserState = {
  users: [],
  userRoles: [],
  terminals: [],
  userPreferences: [],
  visibilitySets: [],
  driver: undefined,
  homeTerminalId: undefined,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  sortBy: '',
  sortField: 'first-name,last-name,suffix',
  recordId: '',
  status: undefined,
  sortAuthTerminals: false,
  addEditModal: {
    open: false,
    method: 'add',
    user: null,
  },
  exportModal: false,
};
